import { render, staticRenderFns } from "./FacebookShare.vue?vue&type=template&id=dfc48872&"
import script from "./FacebookShare.vue?vue&type=script&lang=ts&"
export * from "./FacebookShare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports